<template>

    <form ref="tutorialvideofuncionalidade-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="tutorialVideoModuloId">Tutorial Vídeo Módulo</label>
                <select v-select="{ dataitem: 'TutorialVideoModulo', default: 'Selecione' }" v-model="model.tutorialVideoModuloId" class="form-control" name="tutorialVideoModuloId" required></select>
            </div>
            <div class="form-group col-md-12">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="model.nome" required />
            </div>
            <div class="form-group col-md-12">
                <label for="descricao">Descrição</label>
                <input type="text" class="form-control" name="descricao" placeholder="Descrição" v-model="model.descricao" />
            </div>
            <div class="form-group col-md-12">
                <label for="ordemApresentacao">Ordem de Apresentação</label>
                <input type="number" class="form-control" name="ordemApresentacao" placeholder="Ordem de Apresentação" v-model="model.ordemApresentacao" />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "tutorialvideofuncionalidade-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "tutorialvideofuncionalidade-form-edit",
            
            resources: {
                edit: 'tutorialvideofuncionalidade',
            },

        }),
		
        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false)return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ tutorialVideoFuncionalidadeId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>